import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import MaintainerDashboardScreen from './screens/MaintainerDashboardScreen';

MaintainerDashboard.propTypes = {};

function MaintainerDashboard(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="" element={<MaintainerDashboardScreen />} />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default MaintainerDashboard;
